import { useLanguage } from '../contexts/LanguageContext';

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="language-switcher">
      <button
        className={`flag-button ${language === 'en' ? 'active' : ''}`}
        onClick={() => setLanguage('en')}
        title="English"
      >
        🇬🇧
      </button>
      <button
        className={`flag-button ${language === 'ru' ? 'active' : ''}`}
        onClick={() => setLanguage('ru')}
        title="Русский"
      >
        🇷🇺
      </button>
    </div>
  );
} 